export enum AnalyticsEventType {
  AGREED_TERMS_UPDATE = "AGREED_TERMS_UPDATE",
  CREATE_CLUSTER_START = "CREATE_CLUSTER_START",
  REQUEST_ACCESS_CLICKED = "REQUEST_ACCESS_CLICKED",
  REQUEST_CLUSTER_CANCEL_CLICKED = "REQUEST_CLUSTER_CANCEL_CLICKED",
  REQUEST_CLUSTER_SUBMITTED = "REQUEST_CLUSTER_SUBMITTED",
  REQUEST_CLUSTER_SUBMIT_CLICKED = "REQUEST_CLUSTER_SUBMIT_CLICKED",
  COMPLETED_CLUSTER_CREATION_STEP = "COMPLETED_CLUSTER_CREATION_STEP",
  CLUSTER_TYPE_SELECTED = "CLUSTER_TYPE_SELECTED",
  CLUSTER_SUPPLIER_SELECTED = "CLUSTER_SUPPLIER_SELECTED",
  CLUSTER_SECURITY_COMPLIANCE_SELECTED = "CLUSTER_SECURITY_COMPLIANCE_SELECTED",
  CLUSTER_LOCATIONS_SELECTED = "CLUSTER_LOCATIONS_SELECTED",
  CLUSTER_CONNECTIVITY_TIER_SELECTED = "CLUSTER_CONNECTIVITY_TIER_SELECTED",
  CLUSTER_PROCESSOR_SELECTED = "CLUSTER_PROCESSOR_SELECTED",
  CLUSTER_BASE_IMAGE_SELECTED = "CLUSTER_BASE_IMAGE_SELECTED",
  CLUSTER_QUANTITY_SELECTED = "CLUSTER_QUANTITY_SELECTED",
  CLUSTER_MASTER_NODE_SELECTED = "CLUSTER_MASTER_NODE_SELECTED",
  CLUSTER_ADDITIONAL_KUBERNETES_SERVICES_SELECTED = "CLUSTER_ADDITIONAL_KUBERNETES_SERVICES_SELECTED",
  CLUSTER_DURATION_SELECTED = "CLUSTER_DURATION_SELECTED",
  CLUSTER_PROCESSOR_QUANTITY_SELECTED = "CLUSTER_PROCESSOR_QUANTITY_SELECTED",
  CLUSTER_PAYMENT_BUTTON_CLICKED = "CLUSTER_PAYMENT_BUTTON_CLICKED",
  CLUSTER_CANCEL_DEPLOYMENT_BUTTON_CLICKED = "CLUSTER_CANCEL_DEPLOYMENT_BUTTON_CLICKED",
  CLUSTER_DEPLOY_SELECTED = "CLUSTER_DEPLOY_SELECTED",
  CLUSTER_DEPLOYED_SUCCESSFULLY = "CLUSTER_DEPLOYED_SUCCESSFULLY",
  CLUSTER_RECIPE_SELECTED = "CLUSTER_RECIPE_SELECTED",
  CLUSTER_PROCESSOR_FILTER_SELECTED = "CLUSTER_PROCESSOR_FILTER_SELECTED",
  CLUSTER_PROCESSOR_OPTION_SELECTED = "CLUSTER_PROCESSOR_OPTION_SELECTED",
  CLUSTER_LOCATION_SELECT_ALL_CLICKED = "CLUSTER_LOCATION_SELECT_ALL_CLICKED",
  CLUSTER_PAYMENT_OPTION_SELECTED = "CLUSTER_PAYMENT_OPTION_SELECTED",
  DISCOVER_IO_INVENTORY_BUTTON_CLICK = "DISCOVER_IO_INVENTORY_BUTTON_CLICK",
  IO_INVENTORY_FILTER_CLICK = "IO_INVENTORY_FILTER_CLICK",
  STAKING_CONNECT_WALLET = "STAKING_CONNECT_WALLET",
  STAKING_STAKE_WITH_WRONG_WALLET = "STAKING_STAKE_WITH_WRONG_WALLET",
  STAKING_STAKE_PROCESS_STARTED = "STAKING_STAKE_PROCESS_STARTED",
  STAKING_STAKE_PROCESS_TRANSACTION_FAILED = "STAKING_STAKE_PROCESS_TRANSACTION_FAILED",
  STAKING_STAKE_PROCESS_MIDDLEWARE_FAILED = "STAKING_STAKE_PROCESS_MIDDLEWARE_FAILED",
  STAKING_STAKE_PROCESS_CANCELLED = "STAKING_STAKE_PROCESS_CANCELLED",
  STAKING_STAKE_PROCESS_TIMED_OUT = "STAKING_STAKE_PROCESS_TIMED_OUT",
  STAKING_STAKE_PROCESS_COMPLETED = "STAKING_STAKE_PROCESS_COMPLETED",
  STAKING_STAKE_PROCESS_CAPACITY_REACHED = "STAKING_STAKE_PROCESS_CAPACITY_REACHED",
  STAKING_UNSTAKE_WITH_WRONG_WALLET = "STAKING_UNSTAKE_WITH_WRONG_WALLET",
  STAKING_UNSTAKE_PROCESS_STARTED = "STAKING_UNSTAKE_PROCESS_STARTED",
  STAKING_UNSTAKE_PROCESS_TRANSACTION_FAILED = "STAKING_UNSTAKE_PROCESS_TRANSACTION_FAILED",
  STAKING_UNSTAKE_PROCESS_MIDDLEWARE_FAILED = "STAKING_UNSTAKE_PROCESS_MIDDLEWARE_FAILED",
  STAKING_UNSTAKE_PROCESS_CANCELLED = "STAKING_UNSTAKE_PROCESS_CANCELLED",
  STAKING_UNSTAKE_PROCESS_TIMED_OUT = "STAKING_UNSTAKE_PROCESS_TIMED_OUT",
  STAKING_UNSTAKE_PROCESS_COMPLETED = "STAKING_UNSTAKE_PROCESS_COMPLETED",
  STAKING_UNSTAKE_PROCESS_CAPACITY_REACHED = "STAKING_UNSTAKE_PROCESS_CAPACITY_REACHED",
  STAKING_WITHDRAW_WITH_WRONG_WALLET = "STAKING_WITHDRAW_WITH_WRONG_WALLET",
  STAKING_WITHDRAW_PROCESS_STARTED = "STAKING_WITHDRAW_PROCESS_STARTED",
  STAKING_WITHDRAW_PROCESS_TRANSACTION_FAILED = "STAKING_WITHDRAW_PROCESS_TRANSACTION_FAILED",
  STAKING_WITHDRAW_PROCESS_MIDDLEWARE_FAILED = "STAKING_WITHDRAW_PROCESS_MIDDLEWARE_FAILED",
  STAKING_WITHDRAW_PROCESS_CANCELLED = "STAKING_WITHDRAW_PROCESS_CANCELLED",
  STAKING_WITHDRAW_PROCESS_TIMED_OUT = "STAKING_WITHDRAW_PROCESS_TIMED_OUT",
  STAKING_WITHDRAW_PROCESS_COMPLETED = "STAKING_WITHDRAW_PROCESS_COMPLETED",
  STAKING_WITHDRAW_PROCESS_CAPACITY_REACHED = "STAKING_WITHDRAW_PROCESS_CAPACITY_REACHED",
  TAB_OPENED = "TAB_OPENED",
  MODEL_CLICKED = "MODEL_CLICKED",
  MODEL_SEARCHED = "MODEL_SEARCHED",
  ALL_MODELS_CLICKED = "ALL_MODELS_CLICKED",
  READ_LICENSE_CLICKED = "READ_LICENSE_CLICKED",
  DUMMY_QUERY_CLICKED = "DUMMY_QUERY_CLICKED",
  PROMPT_TYPED = "PROMPT_TYPED",
  TEXT_COPIED = "TEXT_COPIED",
  AGENT_SEARCHED = "AGENT_SEARCHED",
  NEW_CHAT_OPENED = "NEW_CHAT_OPENED",
  AGENT_CLICKED = "AGENT_CLICKED",
  INSTALL_CLICKED = "INSTALL_CLICKED",
  TRY_AGENT_CLICKED = "TRY_AGENT_CLICKED",
  CHAT_WITH_AGENT_CLICKED = "CHAT_WITH_AGENT_CLICKED",
  INJECT_API_KEY_CLICKED = "INJECT_API_KEY_CLICKED",
  CODE_COPIED = "CODE_COPIED",
  AGENT_CLOSED = "AGENT_CLOSED",
  DOCS_CLICKED = "DOCS_CLICKED",
  DOCS_LINK_CLICKED = "DOCS_LINK_CLICKED",
  SUPPORT_CLICKED = "SUPPORT_CLICKED",
  CREATE_NEW_API_KEY_CLICKED = "CREATE_NEW_API_KEY_CLICKED",
  EDIT_API_KEY_CLICKED = "EDIT_API_KEY_CLICKED",
  REVOKE_API_KEY_CLICKED = "REVOKE_API_KEY_CLICKED",
  ADD_SECRET_CLICKED = "ADD_SECRET_CLICKED",
  DELETE_SECRET_CLICKED = "DELETE_SECRET_CLICKED",
  MANAGE_SECRETS_CLICKED = "MANAGE_SECRETS_CLICKED",
  API_KEY_CREATED = "API_KEY_CREATED",
  API_KEY_EDITED = "API_KEY_EDITED",
  API_KEY_REVOKED = "API_KEY_REVOKED",
  API_KEY_INSTRUCTIONS_LINK_CLICKED = "API_KEY_INSTRUCTIONS_LINK_CLICKED",
  SECRET_CREATED = "SECRET_CREATED",
  SECRET_REVOKED = "SECRET_REVOKED",
  PLAYGROUND_REQUEST_RESPONSE_COPIED = "PLAYGROUND_REQUEST_RESPONSE_COPIED",
  PLAYGROUND_RUN_AGENT_CLICKED = "PLAYGROUND_RUN_AGENT_CLICKED",
  SECRET_KEY_INITIATED = "SECRET_KEY_INITIATED",
  FORM_OPENED = "FORM_OPENED",
  FORM_FILLED = "FORM_FILLED",
  SECRET_KEY_CREATED = "SECRET_KEY_CREATED",
  SECRET_KEY_EDITING_INITIATED = "SECRET_KEY_EDITING_INITIATED",
  SECRET_KEY_EDITED = "SECRET_KEY_EDITED",
  SECRET_KEY_REVOKE_INITIATED = "SECRET_KEY_REVOKE_INITIATED",
  SECRET_KEY_REVOKED = "SECRET_KEY_REVOKED",
  SIGNED_IN = "SIGNED_IN",
  SIGN_UP_CLICKED = "SIGN_UP_CLICKED",
  SIGN_UP_INITIATED = "SIGN_UP_INITIATED",
  USER_CREATED = "USER_CREATED",
  RETURN_CLICKED = "RETURN_CLICKED",
  SKIP_THIS_STEP_CLICKED = "SKIP_THIS_STEP_CLICKED",
  PROVIDER_SELECTED = "PROVIDER_SELECTED",
  WALLET_CONNECTION_INITIATED = "WALLET_CONNECTION_INITIATED",
  WALLET_CONNECTED_SUCCESSFULLY = "WALLET_CONNECTED_SUCCESSFULLY",
  BACK_CLICKED = "BACK_CLICKED",
  UPLOAD_FILE_INITIATED = "UPLOAD_FILE_INITIATED",
  FILE_UPLOADED = "FILE_UPLOADED",
  FILE_INFO_CLICKED = "FILE_INFO_CLICKED",
  FILE_DOWNLOAD_CLICKED = "FILE_DOWNLOAD_CLICKED",
  FILE_DELETED = "FILE_DELETED",
  DELETE_ALL_INITIATED = "DELETE_ALL_INITIATED",
  DELETE_ALL_CONFIRMED = "DELETE_ALL_CONFIRMED",
  SEARCH_SETTINGS_OPENED = "SEARCH_SETTINGS_OPENED",
  VECTOR_SEARCH_TOGGLE = "VECTOR_SEARCH_TOGGLE",
  HYBRID_SEARCH_TOGGLE = "HYBRID_SEARCH_TOGGLE",
  GRAPH_SEARCH_TOGGLE = "GRAPH_SEARCH_TOGGLE",
  VECTOR_RESULT_LIMIT = "VECTOR_RESULT_LIMIT",
  VECTOR_INDEX_UPDATED = "VECTOR_INDEX_UPDATED",
  VECTOR_PROBES_ADDED = "VECTOR_PROBES_ADDED",
  VECTOR_EF_ADDED = "VECTOR_EF_ADDED",
  HYBRID_TEXT_WEIGHT_ADDED = "HYBRID_TEXT_WEIGHT_ADDED",
  HYBRID_SEMANTIC_ADDED = "HYBRID_SEMANTIC_ADDED",
  HYBRID_TEXT_LIMIT_ADDED = "HYBRID_TEXT_LIMIT_ADDED",
  HYBRID_RRF_ADDED = "HYBRID_RRF_ADDED",
  RAG_TEMPERATURE_UPDATED = "RAG_TEMPERATURE_UPDATED",
  RAG_TOP_P_UPDATED = "RAG_TOP_P_UPDATED",
  RAG_MAX_TOKENS_UPDATED = "RAG_MAX_TOKENS_UPDATED",
  DUMMY_QUERY_USED = "DUMMY_QUERY_USED",
  CHAT_CLEAR_INITIATED = "CHAT_CLEAR_INITIATED",
  CHAT_CLEAR_RESPONSE = "CHAT_CLEAR_RESPONSE",
  MESSAGE_SENT = "MESSAGE_SENT",
  RESULT_COPIED = "RESULT_COPIED",
  CONTACT_SERVICES_CLICKED = "CONTACT_SERVICES_CLICKED",
  TRENDING_DEVICE_CLICKED = "TRENDING_DEVICE_CLICKED",
  COUNTRY_CLICKED = "COUNTRY_CLICKED",
  EXPLORE_TAB_CLICKED = "EXPLORE_TAB_CLICKED",
  BLOCK_REWARD_CLICKED = "BLOCK_REWARD_CLICKED",
  CLUSTER_CLICKED = "CLUSTER_CLICKED",
  IO_INVENTORY_CLICKED = "IO_INVENTORY_CLICKED",
  INVENTORY_FILTERED = "INVENTORY_FILTERED",
  REQUEST_CLUSTER_CLICKED = "REQUEST_CLUSTER_CLICKED",
  DEVICE_CLICKED = "DEVICE_CLICKED",
  NETWORK_MAP_REGION_SELECTED = "NETWORK_MAP_REGION_SELECTED",
  CLUSTER_SSH_KEY_ADDED = "CLUSTER_SSH_KEY_ADDED",
  CLUSTER_IMAGE_SELECTED = "CLUSTER_IMAGE_SELECTED",
  CLUSTER_NETWORK_SERVICE_ADDED = "CLUSTER_NETWORK_SERVICE_ADDED",
  TRY_CLOUD_CLICKED = "TRY_CLOUD_CLICKED",
  TRY_INTEL_CLICKED = "TRY_INTEL_CLICKED",
  // IO Credits
  REQUEST_CREDIT_CLICKED = "REQUEST_CREDIT_CLICKED",
  REQUEST_CREDIT_SUBMITTED = "REQUEST_CREDIT_SUBMITTED",
  REQUEST_WITHDRAWAL_CLICKED = "REQUEST_WITHDRAWAL_CLICKED",
  REQUEST_WITHDRAWAL_SUBMITTED = "REQUEST_WITHDRAWAL_SUBMITTED",
  PURCHASE_CREDIT_CLICKED = "PURCHASE_CREDIT_CLICKED",
  PURCHASE_CREDIT_SUBMITTED = "PURCHASE_CREDIT_SUBMITTED",
  USE_CLICKED = "USE_CLICKED",
  CLAIM_REWARDS_CLICKED = "CLAIM_REWARDS_CLICKED",
  START_EARNING_CLICKED = "START_EARNING_CLICKED",
  CREDIT_REFUNDED = "CREDIT_REFUNDED",
  CREDIT_WITHDRAWAL_SUCCESSFULL = "CREDIT_WITHDRAWAL_SUCCESSFULL",
  // OTP Login
  OTP_REQUESTED_CODE_COMPLETED = "OTP_REQUESTED_CODE_COMPLETED",
  OTP_REQUESTED_CODE_FAILED = "OTP_REQUESTED_CODE_FAILED",
  OTP_RESENT_CODE_COMPLETED = "OTP_RESENT_CODE_COMPLETED",
  OTP_RESENT_CODE_FAILED = "OTP_RESENT_CODE_FAILED",
  OTP_VERIFIED_CODE_COMPLETED = "OTP_VERIFIED_CODE_COMPLETED",
  OTP_VERIFIED_CODE_FAILED = "OTP_VERIFIED_CODE_FAILED",
  // Agentic Workflow
  AGENT_FLOW_CREATED = "AGENT_FLOW_CREATED",
  COMPONENT_CLICKED = "COMPONENT_CLICKED",
  SAVED_DEPLOYMENT_CONFIG_SAVED = "SAVED_DEPLOYMENT_CONFIG_SAVED",
  SAVED_DEPLOYMENT_CONFIG_LOADED = "SAVED_DEPLOYMENT_CONFIG_LOADED",
  SAVED_DEPLOYMENT_CONFIG_UPDATED = "SAVED_DEPLOYMENT_CONFIG_UPDATED",
  SAVED_DEPLOYMENT_CONFIG_DELETED = "SAVED_DEPLOYMENT_CONFIG_DELETED",
  SAVED_SSH_KEY_ADDED = "SAVED_SSH_KEY_ADDED",
  SAVED_SSH_KEY_DELETED = "SAVED_SSH_KEY_DELETED",
  SAVED_SSH_KEY_DEPLOY_TOGGLED = "SAVED_SSH_KEY_DEPLOY_TOGGLED",
  COMPONENT_AGENT_ADDED = "COMPONENT_AGENT_ADDED",
  COMPONENT_MODEL_ADDED = "COMPONENT_MODEL_ADDED",
  COMPONENT_STAGE_ADDED = "COMPONENT_STAGE_ADDED",
  COMPONENT_TOOL_ADDED = "COMPONENT_TOOL_ADDED",
  COMPONENT_TASK_ADDED = "COMPONENT_TASK_ADDED",
  WORKFLOW_LINK_MADE = "WORKFLOW_LINK_MADE",
  WORKFLOW_RUN_CLICKED = "WORKFLOW_RUN_CLICKED",
  WORKFLOW_DOWNLOADED = "WORKFLOW_DOWNLOADED",
  WORKFLOW_DELETED = "WORKFLOW_DELETED",
  // Training as a Service
  // training home
  TRAINING_STARTED = "TRAINING_STARTED",
  TRAINING_JOB_CLICKED = "TRAINING_JOB_CLICKED",
  // training details
  DOWNLOAD_MODEL_CLICKED = "DOWNLOAD_MODEL_CLICKED",
  ABORT_TRAINING_CLICKED = "ABORT_TRAINING_CLICKED",
  TRAINING_JOB_TAB_CLICKED = "TRAINING_JOB_TAB_CLICKED",
  DOWNLOAD_LOGS_CLICKED = "DOWNLOAD_LOGS_CLICKED",
  // create training
  TRAINING_REQUESTED = "TRAINING_REQUESTED",
  TRAINING_REQUEST_SUBMITTED = "TRAINING_REQUEST_SUBMITTED",
  CREATE_TRAINING_JOB_CLICKED = "CREATE_TRAINING_JOB_CLICKED",
  TRAINING_METHOD_SELECTED = "TRAINING_METHOD_SELECTED",
  TRAINING_BASE_MODEL_SELECTED = "TRAINING_BASE_MODEL_SELECTED",
  TRAINING_DATASET_SELECTED = "TRAINING_DATASET_SELECTED",
  SIGNUP_CLICKED = "SIGNUP_CLICKED",
  // Unified Chat specific
  UNIFIED_CHAT_TOOLPICKER_OPENED = "UNIFIED_CHAT_TOOLPICKER_OPENED",
  UNIFIED_CHAT_TOOL_SELECTED = "UNIFIED_CHAT_TOOL_SELECTED",
  UNIFIED_CHAT_TOOL_REMOVED = "UNIFIED_CHAT_TOOL_REMOVED",
  UNIFIED_CHAT_MODEL_SELECTED = "UNIFIED_CHAT_MODEL_SELECTED",
  UNIFIED_CHAT_PROMPT_TYPED = "UNIFIED_CHAT_PROMPT_TYPED",
  UNIFIED_CHAT_MESSAGE_SENT = "UNIFIED_CHAT_MESSAGE_SENT",
  UNIFIED_CHAT_GENERATION_STOPPED = "UNIFIED_CHAT_GENERATION_STOPPED",
  // Generation and media
  UNIFIED_CHAT_GENERATION_COMPLETED = "UNIFIED_CHAT_GENERATION_COMPLETED",
  UNIFIED_CHAT_GENERATION_FAILED = "UNIFIED_CHAT_GENERATION_FAILED",
  UNIFIED_CHAT_MEDIA_DOWNLOADED = "UNIFIED_CHAT_MEDIA_DOWNLOADED",
  UNIFIED_CHAT_FILE_DOWNLOADED = "UNIFIED_CHAT_FILE_DOWNLOADED",
  // Uploads in unified chat
  UNIFIED_CHAT_UPLOAD_INITIATED = "UNIFIED_CHAT_UPLOAD_INITIATED",
  UNIFIED_CHAT_UPLOAD_COMPLETED = "UNIFIED_CHAT_UPLOAD_COMPLETED",
  UNIFIED_CHAT_UPLOAD_FAILED = "UNIFIED_CHAT_UPLOAD_FAILED",
  UNIFIED_CHAT_DELETE_ALL_INITIATED = "UNIFIED_CHAT_DELETE_ALL_INITIATED",
  UNIFIED_CHAT_DELETE_ALL_COMPLETED = "UNIFIED_CHAT_DELETE_ALL_COMPLETED",
  // Intelligence Account (Plans & Usage) specific
  INTEL_UPGRADE_CLICKED = "INTEL_UPGRADE_CLICKED",
  INTEL_MANAGE_SUBSCRIPTION_CLICKED = "INTEL_MANAGE_SUBSCRIPTION_CLICKED",
  INTEL_PLAN_SUBSCRIBE_CLICKED = "INTEL_PLAN_SUBSCRIBE_CLICKED",
  INTEL_PLAN_SUBSCRIBE_INTENT = "INTEL_PLAN_SUBSCRIBE_INTENT", // When non logged in user clicks on subscribe button
  INTEL_PLAN_PURCHASED = "INTEL_PLAN_PURCHASED",
  INTEL_PLAN_TOGGLE_CLICKED = "INTEL_PLAN_TOGGLE_CLICKED",
  INTEL_CONTACT_US_CLICKED = "INTEL_CONTACT_US_CLICKED",
  INTEL_CONTACT_SALES_OPENED = "INTEL_CONTACT_SALES_OPENED",
  INTEL_CONTACT_SALES_SUBMIT_CLICKED = "INTEL_CONTACT_SALES_SUBMIT_CLICKED",
  INTEL_CONTACT_SALES_SUBMITTED = "INTEL_CONTACT_SALES_SUBMITTED",
  INTEL_CONTACT_SALES_CANCEL_CLICKED = "INTEL_CONTACT_SALES_CANCEL_CLICKED",
  INTEL_PURCHASE_IO_CREDITS_CLICKED = "INTEL_PURCHASE_IO_CREDITS_CLICKED",
  INTEL_QUOTA_LIMIT_DIALOG_UPGRADE_CLICKED = "QUOTA_LIMIT_DIALOG_UPGRADE_CLICKED",
  INTEL_QUOTA_LIMIT_DIALOG_CONTINUE_CLICKED = "INTEL_QUOTA_LIMIT_DIALOG_CONTINUE_CLICKED",
  CHAT_INPUT_UPGRADE_TO_PROFESSIONAL_CLICKED = "CHAT_INPUT_UPGRADE_TO_PROFESSIONAL_CLICKED",
  CHAT_INPUT_UPGRADE_TO_DEVELOPER_CLICKED = "CHAT_INPUT_UPGRADE_TO_DEVELOPER_CLICKED",
  MODEL_TRY_NOW_CLICKED = "MODEL_TRY_NOW_CLICKED",
  PURCHASE_INTENT = "PURCHASE_INTENT",
  PURCHASE_SUCCESS = "PURCHASE_SUCCESS",
  // Vertical Flow specific
  CLUSTER_FILTER_APPLIED = "CLUSTER_FILTER_APPLIED",
  GPU_SEARCHED = "GPU_SEARCHED",
  GPU_MORE_DETAILS_CLICKED = "GPU_MORE_DETAILS_CLICKED",
  CLUSTER_PAY_DEPLOY_API_FAILED = "CLUSTER_PAY_DEPLOY_API_FAILED",
  /** Pay & Deploy blocked because Formik validation failed (missing/invalid fields). */
  CLUSTER_PAY_AND_DEPLOY_VALIDATION_BLOCKED = "CLUSTER_PAY_AND_DEPLOY_VALIDATION_BLOCKED",
  // Feature Flags specific
  PAYMENT_TRUST_SIGNALS_SHOWN = "PAYMENT_TRUST_SIGNALS_SHOWN",
  SSH_HELP_CLICKED = "SSH_HELP_CLICKED",
  SSH_HELP_CODE_COPIED = "SSH_HELP_CODE_COPIED",
  PAYMENT_SAVINGS_MESSAGE_SHOWN = "PAYMENT_SAVINGS_MESSAGE_SHOWN",
  SHOW_ALL_DEVICES_CLICKED = "SHOW_ALL_DEVICES_CLICKED",
  MORE_FILTERS_CLICKED = "MORE_FILTERS_CLICKED",
  MORE_FILTERS_CLOSED = "MORE_FILTERS_CLOSED",
  GPU_SORTED_SELECTED = "GPU_SORTED_SELECTED",
  RECIPE_FIRST_OPT_OUT_CLICKED = "RECIPE_FIRST_OPT_OUT_CLICKED",
  RECIPES_FIRST_RECIPE_SELECTED = "RECIPES_FIRST_RECIPE_SELECTED"
}

export const CONVERSION_EVENTS = [
  AnalyticsEventType.SIGNED_IN,
  AnalyticsEventType.SIGN_UP_CLICKED,
  AnalyticsEventType.SIGN_UP_INITIATED,
  AnalyticsEventType.SIGNUP_CLICKED,
  AnalyticsEventType.USER_CREATED,
  AnalyticsEventType.OTP_VERIFIED_CODE_COMPLETED,
  AnalyticsEventType.OTP_VERIFIED_CODE_FAILED,
  AnalyticsEventType.CLUSTER_DEPLOYED_SUCCESSFULLY,
  AnalyticsEventType.CLUSTER_DEPLOY_SELECTED,
  AnalyticsEventType.CLUSTER_PAYMENT_BUTTON_CLICKED,
  AnalyticsEventType.CREATE_CLUSTER_START,
  AnalyticsEventType.CREATE_TRAINING_JOB_CLICKED,
  AnalyticsEventType.TRAINING_REQUEST_SUBMITTED,
  AnalyticsEventType.MODEL_CLICKED,
  AnalyticsEventType.AGENT_CLICKED,
  AnalyticsEventType.TRY_AGENT_CLICKED,
  AnalyticsEventType.CHAT_WITH_AGENT_CLICKED,
  AnalyticsEventType.INSTALL_CLICKED,
  AnalyticsEventType.UPLOAD_FILE_INITIATED,
  AnalyticsEventType.NEW_CHAT_OPENED,
  AnalyticsEventType.INTEL_PURCHASE_IO_CREDITS_CLICKED,
  AnalyticsEventType.INTEL_CONTACT_US_CLICKED,
  AnalyticsEventType.INTEL_CONTACT_SALES_SUBMITTED,
  AnalyticsEventType.INTEL_PLAN_SUBSCRIBE_CLICKED,
  AnalyticsEventType.INTEL_PLAN_SUBSCRIBE_INTENT,
  AnalyticsEventType.INTEL_UPGRADE_CLICKED,
  AnalyticsEventType.CHAT_INPUT_UPGRADE_TO_PROFESSIONAL_CLICKED,
  AnalyticsEventType.INTEL_PLAN_PURCHASED,
  AnalyticsEventType.PURCHASE_INTENT,
  AnalyticsEventType.PURCHASE_SUCCESS
];
